export default "__VITE_ASSET__CltIop_0__"